
import { useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import { useTranslation } from "react-i18next"
import CustomTimeInput from "./DateEventField"
import { IconCalendar } from "../../utils/Icons/CustomIcons"
import "react-datepicker/dist/react-datepicker.css"

function formatDateUTC(dateString: string, locale: string = 'en-GB') {
  if (!dateString) return ""
  let clean = dateString.replace(/\.\d{6}Z$/, "Z")
  const date = new Date(clean)
  if (isNaN(date.getTime())) return dateString
  const formatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC',
  })
  const parts = formatter.formatToParts(date)
  const y = parts.find(p => p.type === 'year')?.value
  const m = parts.find(p => p.type === 'month')?.value
  const d = parts.find(p => p.type === 'day')?.value
  const h = parts.find(p => p.type === 'hour')?.value
  const min = parts.find(p => p.type === 'minute')?.value
  return `${y}-${m}-${d} ${h}:${min}`
}

function utcStringToLocalDate(utcString: string): Date | null {
  if (!utcString) return null
  let clean = utcString.replace(/\.\d{6}Z$/, "Z")
  const date = new Date(clean)
  if (isNaN(date.getTime())) return null
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000)
}

function localDateToUTCString(date: Date): string {
  if (!date) return ""
  const utc = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  return utc.toISOString().replace(/\.\d{3}Z$/, ".000000Z")
}


const DateEvent = ({ event, setEvent, error, handleChange }: any) => {
  const { t } = useTranslation()

  const [startDate, setStartDate] = useState<string>("")
  const [focus, setFocus] = useState(false)

  useEffect(() => {
    if (event && event.start_datetime) {
      setStartDate(event.start_datetime)
    }
  }, [event])

  const pickerDate = utcStringToLocalDate(startDate)

  return (
    <div
      className={
        error
          ? "profile-input input-item datepicker-item input-error"
          : "profile-input datepicker-item input-item"
      }
    >
      <DatePicker
        autoComplete="off"
        selected={pickerDate}
        onChange={(date: Date) => {
          const utcString = localDateToUTCString(date)
          handleChange(utcString)
          setStartDate(utcString)
          setEvent({ ...event, start_datetime: utcString })
        }}
        dateFormat={`EEEE d MMM, yyyy, HH:mm`}
        showTimeInput={true}
        customTimeInput={
          <CustomTimeInput
            date={pickerDate}
            value={pickerDate}
            onChange={handleChange}
            setFocus={setFocus}
          />
        }
        onFocus={() => {
          setFocus(true)
        }}
        onClickOutside={() => {
          setFocus(false)
        }}
        showDisabledMonthNavigation
        open={focus}
      />

      <label className={startDate || focus ? "active" : ""} htmlFor="">
        {startDate || focus
          ? `Date*: ${formatDateUTC(startDate, t('locale') || 'en-GB')}`
          : "Pick date*"}
      </label>

      <IconCalendar className="icon" />

      {error && <span className="input-item__error error mt-1">{error}</span>}
    </div>
  )
}

export default DateEvent
